import type { Story } from '@/store/story-types'

export const SOCIAL_MARKETPLACE_STORY: Story = {
  id: 'social-marketplace',
  name: 'ShopSocial — Social Commerce Marketplace',
  narrative: 'A social commerce marketplace with a shoppable creator feed, trending product discovery, and seamless in-app purchasing.',
  goals: ['Browse social commerce feed', 'Discover trending products', 'View product details from creator posts', 'Purchase directly from the feed'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'ShopSocial — Feed', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'home',
      description: 'Main feed page with navbar, shoppable creator posts, trending products section, and footer',
      blockRef: { category: 'social', blockId: 'sm-feed' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Social Feed',
      description: 'Visitor browses the social commerce feed with creator posts',
      steps: [
        { type: 'given', text: 'the visitor opens the marketplace' },
        { type: 'when', text: 'the feed page loads' },
        { type: 'then', text: 'shoppable creator posts with product tags are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Discover Trending Products',
      description: 'Visitor scrolls to see trending products',
      steps: [
        { type: 'given', text: 'the visitor is on the feed page', linkedPageId: 'home' },
        { type: 'when', text: 'they scroll past the creator posts' },
        { type: 'then', text: 'a trending products section with popular items is visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Tap Product in Feed',
      description: 'Visitor taps a tagged product in a creator post',
      steps: [
        { type: 'given', text: 'the visitor sees a shoppable post', linkedPageId: 'home' },
        { type: 'when', text: 'they tap a product tag in the post' },
        { type: 'then', text: 'a product detail overlay shows price, description, and a buy button', linkedFlowId: 'showProductDetail' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Purchase from Feed',
      description: 'Visitor purchases a product directly from the feed',
      steps: [
        { type: 'given', text: 'the visitor is viewing a product detail' },
        { type: 'when', text: 'they tap the Buy Now button' },
        { type: 'then', text: 'the purchase flow initiates with cart and checkout', linkedFlowId: 'quickPurchase' },
      ],
    },
  ],
}
